// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class ProjectSummaryPlant {
  readonly plantId: string;
  readonly plantName: string;

  constructor(data: { [key: string]: any } = {}) {
    this.plantId = data.plantId === undefined ? NIL_UUID : data.plantId;
    this.plantName = data.plantName === undefined ? '' : data.plantName;
  }

  static zero(): ProjectSummaryPlant {
    const zeroValues: ExcludeMethodsDeep<ProjectSummaryPlant> = {
      plantId: NIL_UUID,
      plantName: '',
    };
    return new ProjectSummaryPlant(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ProjectSummaryPlantWireFormat = {
  plantId: string;
  plantName: string;
};

type NewProjectSummaryPlantProps = PartialDeep<ProjectSummaryPlant, { recurseIntoArrays: true }>;
export const NewProjectSummaryPlant: (props: NewProjectSummaryPlantProps) => ProjectSummaryPlant = (
  props,
) => new ProjectSummaryPlant(props);

type NewProjectSummaryPlantFromWireFormatProps = PartialDeep<
  ProjectSummaryPlantWireFormat,
  { recurseIntoArrays: true }
>;
export const NewProjectSummaryPlantFromWireFormat: (
  props: NewProjectSummaryPlantFromWireFormatProps,
) => ProjectSummaryPlant = (props) => new ProjectSummaryPlant(props);
